import React, { Component } from 'react';
import {
    TableHead,
    TableRow,
    TableCell,
    Typography
} from '@material-ui/core';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
/* import SearchInput from './SearchInput';
import NumberFormat from 'react-number-format'; */

class SortingAndFiltering extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sort: ''
        };
    }

    render() {
        return (
            <TableHead>
                <TableRow>
                    {this.props.columns.map((column, index) => {
                        if (column.sort) {
                            return <TableCell
                                key={"sort-" + index}
                                component="th" scope="row" width={column.width} align={column.align} style={{ paddingTop: 0, paddingBottom: 0, height: "36.5px" }}>
                                <Typography style={{ display: 'inline' }}>
                                    {column.name}
                                </Typography>
                                {this.props.filter.sort === null || this.props.filter.sort !== column.dbName + ",DESC" ?
                                    <ArrowUpward onClick={() => this.props.onSortChange(column.dbName + ",DESC")} style={{ float: "right", cursor: "pointer" }} /> :
                                    <ArrowDownward onClick={() => this.props.onSortChange(column.dbName + ",ASC")} style={{ float: "right", cursor: "pointer" }} />
                                }
                            </TableCell>
                        } else {
                            return <TableCell key={"sort-" + index} className="header-table-cell" component="th" scope="row" align={column.align} width={column.width}>{column.name}</TableCell>
                        }
                    })}
                </TableRow>{/* 
                <TableRow>
                    {this.props.columns.map((column, index) => {
                        if (column.filter) {
                            return <TableCell key={"filter-" + index} className="search-table-cell">
                                {!column.type &&
                                    <SearchInput
                                        id={column.dbName}
                                        name={column.dbName}
                                        type={column.type}
                                        value={this.props.filter[column.dbName]}
                                        onChange={(e) => this.props.onFilterChange(e)}
                                        onSearch={(e) => this.props.onFilterSearch(e)}
                                        onClear={(e) => this.props.onFilterClear(e)}
                                    />}

                                {column.type && (column.type === "number" || column.type === "big-decimal") &&
                                    <NumberFormat
                                        id={column.dbName}
                                        name={column.dbName}
                                        label={"Search..."}
                                        thousandSeparator={column.thousandSeparator}
                                        decimalSeparator={column.thousandSeparator}
                                        decimalScale={column.decimalScale}
                                        fixedDecimalScale={true}
                                        onChange={(e) => this.props.onFilterChange(e)}
                                        onSearch={(e) => this.props.onFilterSearch(e)}
                                        onClear={(e) => this.props.onFilterClear(e)}
                                        placeholder="Search..."
                                        value={this.props.filter[column.dbName] || ''}
                                        customInput={SearchInput}
                                    />}
                            </TableCell>
                        } else {
                            return <TableCell key={"filter-" + index} className="table-cell" />
                        }
                    })}
                </TableRow> */}
            </TableHead>
        );
    }
}

export default SortingAndFiltering;
